// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Merchant Subscription Styles */
.merchant-subscription {
    padding: 24px;
}

.merchant-subscription .MuiCard-root {
    margin-bottom: 24px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.merchant-subscription .MuiCard-root:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.merchant-subscription .MuiCardContent-root {
    padding: 24px;
}

.merchant-subscription .MuiCardActions-root {
    padding: 16px 24px;
    justify-content: center;
}

.merchant-subscription .MuiTypography-h5 {
    margin-bottom: 16px;
    color: #1976d2;
}

.merchant-subscription .MuiTypography-h6 {
    margin-bottom: 12px;
    color: #333;
}

.merchant-subscription .MuiTypography-body2 {
    color: #666;
    margin-bottom: 8px;
}

.merchant-subscription .MuiButton-root {
    text-transform: none;
    font-weight: 500;
}

.merchant-subscription .MuiButton-contained {
    background-color: #1976d2;
    color: white;
}

.merchant-subscription .MuiButton-outlined {
    border-color: #1976d2;
    color: #1976d2;
}

.merchant-subscription .MuiChip-root {
    margin: 4px;
}

.merchant-subscription .MuiLinearProgress-root {
    height: 8px;
    margin-bottom: 8px;
}

.merchant-subscription .MuiDialog-root .MuiDialogContent-root {
    padding: 24px;
}

.merchant-subscription .MuiDialog-root .MuiDialogActions-root {
    padding: 16px 24px;
}

.merchant-subscription .MuiTableContainer-root {
    margin-top: 16px;
}

.merchant-subscription .MuiTableHead-root .MuiTableCell-root {
    font-weight: 600;
    background-color: #f5f5f5;
}

.merchant-subscription .MuiTableBody-root .MuiTableRow-root:hover {
    background-color: #f8f9fa;
}

/* Package cards */
.merchant-subscription .package-card {
    height: 100%;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.merchant-subscription .package-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.merchant-subscription .package-card.current {
    border: 2px solid #4caf50;
}

.merchant-subscription .package-card.upgrade {
    border: 2px solid #ff9800;
}

.merchant-subscription .package-card.downgrade {
    border: 2px solid #2196f3;
}

/* Price display */
.merchant-subscription .price-display {
    margin-bottom: 16px;
}

.merchant-subscription .price-display .MuiTypography-h3 {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0;
    color: #1976d2;
}

/* Features */
.merchant-subscription .features {
    margin-bottom: 16px;
}

.merchant-subscription .features p {
    margin-bottom: 8px;
    font-size: 0.9rem;
}

/* Status indicators */
.merchant-subscription .status-indicator {
    margin-left: 8px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .merchant-subscription {
        padding: 16px;
    }
    
    .merchant-subscription .MuiCardContent-root {
        padding: 16px;
    }
    
    .merchant-subscription .MuiGrid-item {
        margin-bottom: 16px;
    }
}

.merchant-subscription .badge.bg-secondary {
    background-color: #6c757d !important;
}

/* Progress bars */
.merchant-subscription .progress-bar.bg-success {
    background-color: #198754 !important;
}

.merchant-subscription .progress-bar.bg-warning {
    background-color: #ffc107 !important;
}

.merchant-subscription .progress-bar.bg-danger {
    background-color: #dc3545 !important;
}

/* Table styling */
.merchant-subscription .table th {
    background-color: #f8f9fa;
    border-top: none;
    font-weight: 600;
    color: #495057;
    font-size: 0.875rem;
}

.merchant-subscription .table td {
    vertical-align: middle;
    font-size: 0.875rem;
}

.merchant-subscription .text-danger {
    color: #dc3545 !important;
}

.merchant-subscription .text-success {
    color: #198754 !important;
}

.merchant-subscription .text-muted {
    color: #6c757d !important;
}

/* Button styling */
.merchant-subscription .btn-primary {
    background-color: #0d6efd;
    border-color: #0d6efd;
}

.merchant-subscription .btn-warning {
    background-color: #ffc107;
    border-color: #ffc107;
    color: #212529;
}

.merchant-subscription .btn-outline-secondary {
    color: #6c757d;
    border-color: #6c757d;
}

.merchant-subscription .btn-outline-secondary:hover {
    background-color: #6c757d;
    border-color: #6c757d;
}

/* Current subscription card */
.merchant-subscription .current-subscription {
    border-left: 4px solid #198754;
}

.merchant-subscription .current-subscription .card-header {
    background-color: #d1e7dd;
    color: #0f5132;
}

/* Notifications */
.merchant-subscription .alert-warning {
    background-color: #fff3cd;
    border-color: #ffecb5;
    color: #664d03;
}

.merchant-subscription .alert-danger {
    background-color: #f8d7da;
    border-color: #f5c2c7;
    color: #842029;
}

.merchant-subscription .alert-info {
    background-color: #d1ecf1;
    border-color: #b8daff;
    color: #055160;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .merchant-subscription {
        padding: 10px;
    }
    
    .merchant-subscription .d-flex.justify-content-between {
        flex-direction: column;
        gap: 15px;
    }
    
    .merchant-subscription .price-display h3 {
        font-size: 1.5rem;
    }
    
    .merchant-subscription .table-responsive {
        font-size: 0.75rem;
    }
    
    .merchant-subscription .btn {
        font-size: 0.875rem;
        padding: 0.5rem 1rem;
    }
    
    .merchant-subscription .modal-dialog {
        margin: 0.5rem;
    }
}

/* Animation for loading */
.merchant-subscription .spinner-border {
    animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
    to {
        transform: rotate(360deg);
    }
}

/* Custom utility classes */
.merchant-subscription .text-center {
    text-align: center !important;
}

.merchant-subscription .mb-0 {
    margin-bottom: 0 !important;
}

.merchant-subscription .mt-2 {
    margin-top: 0.5rem !important;
}

.merchant-subscription .me-2 {
    margin-right: 0.5rem !important;
}

.merchant-subscription .py-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
} `, "",{"version":3,"sources":["webpack://./src/components/Merchant/Subscription/MerchantSubscription.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,mEAAmE;AACvE;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,mEAAmE;AACvE;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA,kBAAkB;AAClB;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,8BAA8B;AAC9B;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,2BAA2B;AAC3B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA,0BAA0B;AAC1B;IACI,+CAA+C;AACnD;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,2BAA2B;AAC3B;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC","sourcesContent":["/* Merchant Subscription Styles */\n.merchant-subscription {\n    padding: 24px;\n}\n\n.merchant-subscription .MuiCard-root {\n    margin-bottom: 24px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.merchant-subscription .MuiCard-root:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.merchant-subscription .MuiCardContent-root {\n    padding: 24px;\n}\n\n.merchant-subscription .MuiCardActions-root {\n    padding: 16px 24px;\n    justify-content: center;\n}\n\n.merchant-subscription .MuiTypography-h5 {\n    margin-bottom: 16px;\n    color: #1976d2;\n}\n\n.merchant-subscription .MuiTypography-h6 {\n    margin-bottom: 12px;\n    color: #333;\n}\n\n.merchant-subscription .MuiTypography-body2 {\n    color: #666;\n    margin-bottom: 8px;\n}\n\n.merchant-subscription .MuiButton-root {\n    text-transform: none;\n    font-weight: 500;\n}\n\n.merchant-subscription .MuiButton-contained {\n    background-color: #1976d2;\n    color: white;\n}\n\n.merchant-subscription .MuiButton-outlined {\n    border-color: #1976d2;\n    color: #1976d2;\n}\n\n.merchant-subscription .MuiChip-root {\n    margin: 4px;\n}\n\n.merchant-subscription .MuiLinearProgress-root {\n    height: 8px;\n    margin-bottom: 8px;\n}\n\n.merchant-subscription .MuiDialog-root .MuiDialogContent-root {\n    padding: 24px;\n}\n\n.merchant-subscription .MuiDialog-root .MuiDialogActions-root {\n    padding: 16px 24px;\n}\n\n.merchant-subscription .MuiTableContainer-root {\n    margin-top: 16px;\n}\n\n.merchant-subscription .MuiTableHead-root .MuiTableCell-root {\n    font-weight: 600;\n    background-color: #f5f5f5;\n}\n\n.merchant-subscription .MuiTableBody-root .MuiTableRow-root:hover {\n    background-color: #f8f9fa;\n}\n\n/* Package cards */\n.merchant-subscription .package-card {\n    height: 100%;\n    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.merchant-subscription .package-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 4px 8px rgba(0,0,0,0.15);\n}\n\n.merchant-subscription .package-card.current {\n    border: 2px solid #4caf50;\n}\n\n.merchant-subscription .package-card.upgrade {\n    border: 2px solid #ff9800;\n}\n\n.merchant-subscription .package-card.downgrade {\n    border: 2px solid #2196f3;\n}\n\n/* Price display */\n.merchant-subscription .price-display {\n    margin-bottom: 16px;\n}\n\n.merchant-subscription .price-display .MuiTypography-h3 {\n    font-size: 2rem;\n    font-weight: 700;\n    margin-bottom: 0;\n    color: #1976d2;\n}\n\n/* Features */\n.merchant-subscription .features {\n    margin-bottom: 16px;\n}\n\n.merchant-subscription .features p {\n    margin-bottom: 8px;\n    font-size: 0.9rem;\n}\n\n/* Status indicators */\n.merchant-subscription .status-indicator {\n    margin-left: 8px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .merchant-subscription {\n        padding: 16px;\n    }\n    \n    .merchant-subscription .MuiCardContent-root {\n        padding: 16px;\n    }\n    \n    .merchant-subscription .MuiGrid-item {\n        margin-bottom: 16px;\n    }\n}\n\n.merchant-subscription .badge.bg-secondary {\n    background-color: #6c757d !important;\n}\n\n/* Progress bars */\n.merchant-subscription .progress-bar.bg-success {\n    background-color: #198754 !important;\n}\n\n.merchant-subscription .progress-bar.bg-warning {\n    background-color: #ffc107 !important;\n}\n\n.merchant-subscription .progress-bar.bg-danger {\n    background-color: #dc3545 !important;\n}\n\n/* Table styling */\n.merchant-subscription .table th {\n    background-color: #f8f9fa;\n    border-top: none;\n    font-weight: 600;\n    color: #495057;\n    font-size: 0.875rem;\n}\n\n.merchant-subscription .table td {\n    vertical-align: middle;\n    font-size: 0.875rem;\n}\n\n.merchant-subscription .text-danger {\n    color: #dc3545 !important;\n}\n\n.merchant-subscription .text-success {\n    color: #198754 !important;\n}\n\n.merchant-subscription .text-muted {\n    color: #6c757d !important;\n}\n\n/* Button styling */\n.merchant-subscription .btn-primary {\n    background-color: #0d6efd;\n    border-color: #0d6efd;\n}\n\n.merchant-subscription .btn-warning {\n    background-color: #ffc107;\n    border-color: #ffc107;\n    color: #212529;\n}\n\n.merchant-subscription .btn-outline-secondary {\n    color: #6c757d;\n    border-color: #6c757d;\n}\n\n.merchant-subscription .btn-outline-secondary:hover {\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n\n/* Current subscription card */\n.merchant-subscription .current-subscription {\n    border-left: 4px solid #198754;\n}\n\n.merchant-subscription .current-subscription .card-header {\n    background-color: #d1e7dd;\n    color: #0f5132;\n}\n\n/* Notifications */\n.merchant-subscription .alert-warning {\n    background-color: #fff3cd;\n    border-color: #ffecb5;\n    color: #664d03;\n}\n\n.merchant-subscription .alert-danger {\n    background-color: #f8d7da;\n    border-color: #f5c2c7;\n    color: #842029;\n}\n\n.merchant-subscription .alert-info {\n    background-color: #d1ecf1;\n    border-color: #b8daff;\n    color: #055160;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .merchant-subscription {\n        padding: 10px;\n    }\n    \n    .merchant-subscription .d-flex.justify-content-between {\n        flex-direction: column;\n        gap: 15px;\n    }\n    \n    .merchant-subscription .price-display h3 {\n        font-size: 1.5rem;\n    }\n    \n    .merchant-subscription .table-responsive {\n        font-size: 0.75rem;\n    }\n    \n    .merchant-subscription .btn {\n        font-size: 0.875rem;\n        padding: 0.5rem 1rem;\n    }\n    \n    .merchant-subscription .modal-dialog {\n        margin: 0.5rem;\n    }\n}\n\n/* Animation for loading */\n.merchant-subscription .spinner-border {\n    animation: spinner-border 0.75s linear infinite;\n}\n\n@keyframes spinner-border {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Custom utility classes */\n.merchant-subscription .text-center {\n    text-align: center !important;\n}\n\n.merchant-subscription .mb-0 {\n    margin-bottom: 0 !important;\n}\n\n.merchant-subscription .mt-2 {\n    margin-top: 0.5rem !important;\n}\n\n.merchant-subscription .me-2 {\n    margin-right: 0.5rem !important;\n}\n\n.merchant-subscription .py-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
